import axios from 'axios'
import VueAxios from 'vue-axios'
import { loadExtensions } from './nette/NetteAjax'
import directives from './directives'
import components from './components'
import store from './store'
import './views'
import VueClickAway from "vue3-click-away";
import formatBytes from './utils/formatBytes'
import formatDate from './utils/formatDate'
import { vueI18next, initTranslator, setDebug } from './vuei18next'
import { createPinia } from 'pinia'
import { setApiKey as gmapsSetApiKey } from './utils/loadGMaps'

export default function install(vueApp, context) {
  vueApp.use(VueAxios, axios)
  loadExtensions(context.netteAjaxExt, context)

  // load translator
  vueApp.use(vueI18next)

  if (window?.netteInitialState?.prod !== undefined) {
    context.prod = window.netteInitialState.prod
    setDebug(!context.prod)
  }
  
  if (window?.netteInitialState?.translator) {
    initTranslator(window.netteInitialState.translator.lang, window.netteInitialState.translator.group.toString(), window.netteInitialState.translator.translates)
  }

  // load directives
  vueApp.use(createPinia())
  vueApp.use(store)
  vueApp.use(VueClickAway)
  vueApp.use(directives, context)
  vueApp.use(components, context)

  // global properties
  vueApp.config.globalProperties.formatBytes = formatBytes
  vueApp.config.globalProperties.formatDate = formatDate

  // google maps keys
  if (context.googleMapsApiKey) {
    gmapsSetApiKey(context.googleMapsApiKey)
  }
}